import React from 'react';
import { useSession } from '../context/SessionContext';
import { t } from '../services/sessionManager';
import { AppHeaderIcon } from './ui/AppHeaderIcon';
import { CookieBanner } from './ui/CookieBanner';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { themeNotice, language } = useSession();

  return (
    <div className="min-h-screen flex flex-col font-sans bg-gray-50 dark:bg-slate-950 text-gray-900 dark:text-white transition-colors duration-200">
      
      {/* App Header Section */}
      <div className="w-full bg-white dark:bg-slate-900 border-b border-gray-100 dark:border-slate-800 shadow-sm transition-colors duration-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center space-x-4">
          <AppHeaderIcon className="w-12 h-12 sm:w-16 sm:h-16 shrink-0" />
          <h1 className="text-3xl sm:text-4xl font-black font-nexa tracking-tight text-gray-900 dark:text-white">
            CleanTXT
          </h1>
        </div>
      </div>

      <main className="flex-grow w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 relative">
        {children}
      </main>

      <footer className="border-t border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900 py-6 transition-colors duration-200">
        <div className="max-w-5xl mx-auto px-4 text-center text-sm text-gray-400 dark:text-slate-500">
          &copy; {new Date().getFullYear()} {t('copyright', language)}
        </div>
      </footer>

      {/* Joisst Cookie Consent System */}
      <CookieBanner />

      {/* Theme Sync Notice Toast */}
      {themeNotice && (
        <div className="fixed bottom-4 right-4 z-50 animate-bounce-in">
          <div className="bg-gray-900 dark:bg-white text-white dark:text-gray-900 px-4 py-3 rounded-lg shadow-lg flex items-center space-x-3 text-sm font-medium border border-gray-700 dark:border-gray-200">
             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5 text-green-400 dark:text-green-600">
               <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
             </svg>
             <span>{themeNotice}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;